import { Injectable } from '@angular/core';
import { DataPoint } from '../models/modal-graph-forecast';

@Injectable({
  providedIn: 'root'
})
export class PiezoDataService {

  constructor() { }

  processPiezoData(scenarioPiezo: any): { piezo: DataPoint[], piezoRealtime: DataPoint[] } {
    const piezo: DataPoint[] = [];
    const piezoRealtime: DataPoint[] = [];

    scenarioPiezo.forEach((element: { SensorType: string, result: any }) => {
      if (element.SensorType === "Piezo") {
        this.addDataPoints(element.result[0], piezo);
        this.addDataPoints(element.result[1], piezoRealtime);
      }
    });

    return { piezo, piezoRealtime };
  }

  private addDataPoints(result: any[], targetArray: DataPoint[]): void {
    result.forEach(point => {
      targetArray.push({ date: point.date, value: point.value });
    });
  }
}
